import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DataItem } from '../model/data.item';

@Component({
    selector: 'ess-breadcrumbs',
    templateUrl: './breadcrumbs.html',
    styleUrls: ['./breadcrumbs.scss']
})
export class BreadCrumbsComponent implements OnInit, OnChanges {

    @Input('lookup')
    data: DataItem[] = [];

    @Input('prompt')
    prompt: string;

    @Output('select')
    onSelect: EventEmitter<DataItem> = new EventEmitter<DataItem>();

    path: DataItem[] = [];
    currentSegment: DataItem;
    currentLevel: DataItem[] = [];

    ngOnInit() {
        this.setRoot();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.setRoot();
        }
    }

    setRoot() {
        this.setLevel(null);
        /*if (this.data && this.data.length) {
            this.path = [this.data[0]];
            this.setLevel(this.path[0]);
            // this.currentLevel = this.data;
        }*/
    }

    selectItem(item: DataItem) {
        
        if (this.currentSegment) {
            let level = this.path.indexOf(this.currentSegment);
            if (level >= 0) {
                this.path = this.path.slice(0, level + 1);
            } else {
                this.path = []
            }
        } else {
            this.path = [];
        }
        this.currentSegment = item;
        // let level = this.path.indexOf(item);
        // if (level >= 0) {
        //     this.path = this.path.slice(0, level);
        // } else {
        //     this.path = [];
        // }
        this.path.push(item);

        /*if (this.currentSegment) {
            let level = this.path.indexOf(this.currentSegment);
            this.path.splice(level, 1, item);
            this.currentSegment = item;
            this.path = this.path.slice(0, level + 1);
        }
        if (item.children && item.children.length) {
            this.path.push(item.children[0]);
        }
        */
        this.onSelect.emit(item);
    }

    setLevel(segment: DataItem) {
        this.currentSegment = segment;
        if (segment) {
            this.currentLevel = segment.children;
        } else {
            this.currentLevel = this.data;
        }
        // this.currentSegment = segment;
        // this.currentLevel = segment.children; // this.getSiblings(segment, this.data);
    }

    setLevelIndex(index: number) {
        this.currentSegment = this.path[index];
        this.currentLevel = this.getSiblings(this.currentSegment, this.data);
    }

    getSiblings(item: DataItem, search: DataItem[]): DataItem[] {
        for(let child of search) {
            if (item == child) {
                return search;
            }
            let found = this.getSiblings(item, child.children);
            if (found && found.length) {
                return found;
            }
        }
        return [];
    }
}